/**
 * OnboardingProvider
 * Provides onboarding context and state management across the application
 */
import React, { createContext, useContext } from 'react';
import { useOnboarding, OnboardingState } from '@/hooks/useOnboarding';
import { OnboardingStatus } from '@/services/api/onboardingService';
import { OnboardingScenario as UIOnboardingScenario } from '@/types/onboarding';

interface OnboardingContextValue extends OnboardingState {
  checkOnboardingStatus: () => Promise<OnboardingStatus | null>;
  initializeOnboarding: (scenario: UIOnboardingScenario) => Promise<OnboardingStatus | null>;
  updateStage: (newStage: string) => Promise<OnboardingStatus | null>;
  completeOnboarding: () => Promise<OnboardingStatus | null>;
}

const OnboardingContext = createContext<OnboardingContextValue | undefined>(undefined);

export function OnboardingProvider({ children }: { children: React.ReactNode }) {
  const onboarding = useOnboarding();

  return (
    <OnboardingContext.Provider value={onboarding}>
      {children}
    </OnboardingContext.Provider>
  );
}

export function useOnboardingContext() {
  const context = useContext(OnboardingContext);
  if (context === undefined) {
    throw new Error('useOnboardingContext must be used within an OnboardingProvider');
  }
  return context;
}
